module.exports.ErrorCodes = {
  generic: {
    ROUTE_DEPRECATED: 'route_deprecated',
    RESOURCE_NOT_FOUND: 'resource_not_found',
    BAD_REQUEST: 'bad_request',
    NOT_IMPLEMENTED: 'not_implemented',
    SERVER_ERROR: 'server_error',
    DATABASE_ERROR: 'database_error',
    MISSING_DATA: 'missing_data',
  },
  auth: {
    ACCESS_DENIED: 'access_denied',
  },
  activity: {
    CANNOT_DELETE_DUE_TO_DEPENDENCIES: 'cannot_delete_due_to_dependencies'
  },
  booking: {
    NO_AVAILABILITY: 'no_availability',
    WRONG_PRICE_BREAKDOWN: 'wrong_price_breakdown',
    WRONG_REBATE: 'wrong_rebate',
    WRONG_TOTAL: 'wrong_total',
    PLAUSIBILITY_ERROR: 'plausibility_error',
    BOOKER_NAME_REQUIRED: 'booker_name_required',
    BOOKER_EMAIL_REQUIRED: 'booker_email_required',
    BOOKING_STATUS_NOT_ELLIGIBLE: 'booking_status_not_elligible',
    CANCELLATION_NOT_ELLIGIBLE: 'cancellation_not_elligible',
    PRODUCT_DESCRIPTION_NOT_AVAILABLE_IN_GIVEN_LANGUAGE: 'product_description_not_available_in_given_language'
  },
  payment: {
    INTENT_CREATION_FAILED: "intent_creation_failed",
    INVALID_INTENT: "invalid_intent",
    CAPTURE_FAILED: "capture_failed",
    AUTHORIZATION_FAILED: "authorization_failed",
    UNKNOWN_ACTION: "unknown_action"
  },
  slot: {
    VARIANT_ID_NOT_FOUND: 'variant_id_not_found',
    CANNOT_DELETE_SLOT_WITH_BOOKINGS: 'cannot_delete_slot_with_bookings'
  }
}